<template>
    <div class="card border-0 no-shadow bg-wash">
        <div class="row no-gutters py-2 mb-3">
            <div class="ml-0 col-md-6">
                <div class="custom-search">
                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search Attribute" v-model="search"
                            @input="resetPagination()"></b-form-input>
                    </b-input-group>
                </div>
            </div>
            <div class="col-md-6 text-right pr-0">
                <b-button id="show-btn" @click="addNewAttribute()"><b-icon icon="plus"></b-icon> Add Custom
                    Field</b-button>
            </div>
        </div>

        <b-alert show dismissible fade v-if='successmsg'>{{ successmsg }}</b-alert>

        <b-overlay :show="showoverlay" rounded="sm">
            <!-- Abdullah26 maked it table formate  -->
            <!-- alpha fix- removed class list-table and added border class  -->
            <table class="table border">
                <thead>
                    <tr class="table-head">
                        <td>Field Name</td>
                        <td>Field Type</td>
                        <td>Linked with Contract</td>
                        <td> Linked with CTC</td>
                        <td style="width: 100px;">Action</td>
                    </tr>
                </thead>

                <tbody>
                    <tr class="hover-bg table-row border-bottom mx-2" v-for="custom_attribute in paginatedData"
                        :key="custom_attribute.id">
                        <td> {{ custom_attribute.label }}</td>
                        <td>{{ types[custom_attribute.type].text }}</td>
                        <td>{{ yes_no[custom_attribute.link_to_contract].text }}</td>
                        <td>{{ custom_attribute.is_ctc == 1 ? 'Yes' : 'No' }}</td>
                        <td class="float-right">
                            <div class="float-right mr-2 position-relative">
                                <b-button-toolbar class="d-block">
                                    <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                        style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false"><b-icon
                                            icon="three-dots-vertical"></b-icon></a>
                                            <!-- alpha fix- added px-1 -->
                                    <div class="dropdown-menu action-dropdown-menu px-1" aria-labelledby="actionDropdown">
                                        <b-button-group>
                                            <!-- alpha fix added text-left in both btn  -->
                                            <b-button variant="outline-secondary" class="text-left"
                                                @click="editCustomAttribute(custom_attribute.id)">
                                                <b-icon icon="pencil"></b-icon> Edit
                                            </b-button>
                                            <b-button variant="outline-secondary" class="text-left"
                                                @click="removeAttribute(custom_attribute.id)">
                                                <b-icon icon="trash"></b-icon> Delete
                                            </b-button>
                                        </b-button-group>
                                    </div>
                                </b-button-toolbar>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell text-center">No Result Found!</div>
            <div v-else class="row py-2 no-margin">
                <div class="col-md-12 p-0 no-margin">
                    <ul class="pagination b-pagination float-left mb-0 mt-1">
                        <li class="page-item disabled m-2">View</li>
                        <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options"
                                @change="setFirstPage()"></b-form-select></li>
                        <li class="page-item disabled m-2">per page. Total {{ people }} records found.</li>
                    </ul>
                    <b-pagination-nav v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#"
                        first-number last-number><template #prev-text><span>Previous</span></template><template
                            #next-text><span>Next</span></template></b-pagination-nav>
                </div>
            </div>


            <!-- Abdullah26 commented this  -->
            <!-- <div class="card-body container-fluid pt-1 table-layout px-0">
                <div class="row table-head no-margin">
                    <div
                        :class="[is_ctc_module_available ? 'col-sm-3' : 'col-sm-4', 'px-0 py-2 pl-2 font-weight-bold align-self-center']">
                        Field Name
                    </div>
                    <div
                        :class="[is_ctc_module_available ? 'col-sm-3' : 'col-sm-4', 'px-0 py-2 font-weight-bold align-self-center']">
                        Field Type
                    </div>
                    <div class="col-sm-2  px-0 py-2 font-weight-bold align-self-center">
                        Linked with Contract
                    </div>
                    <div v-if="is_ctc_module_available" class="col-sm-2 px-0 py-2 font-weight-bold align-self-center">
                        Linked with CTC
                    </div>
                    <div class="col-sm-2  px-2 py-2 font-weight-bold text-right">
                        Action
                    </div>
                </div>


                <div class="row border-bottom py-10 hover-bg table-row no-margin"
                    v-for="custom_attribute in paginatedData" :key="custom_attribute.id">

                    <div
                        :class="[is_ctc_module_available ? 'col-sm-3' : 'col-sm-4', 'py-1 px-0 pl-2 align-self-center']">
                        {{ custom_attribute.label }}
                    </div>
                    <div :class="[is_ctc_module_available ? 'col-sm-3' : 'col-sm-4', 'py-1 px-0 align-self-center']">
                        {{ types[custom_attribute.type].text }}
                    </div>
                    <div class="col-sm-2 py-1 px-0 align-self-center">
                        {{ yes_no[custom_attribute.link_to_contract].text }}
                    </div>
                    <div v-if="is_ctc_module_available" class="col-sm-2 py-1 px-0 align-self-center">
                        {{ custom_attribute.is_ctc == 1 ? 'Yes' : 'No' }}
                    </div>
                    <div class="col-sm-2 py-1 px-2 text-right position-relative">
                        <b-button-toolbar class="d-block">
                            <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false"><b-icon
                                    icon="three-dots-vertical"></b-icon></a>
                            <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                <b-button-group>
                                    <b-button variant="outline-secondary"
                                        @click="editCustomAttribute(custom_attribute.id)">
                                        <b-icon icon="pencil"></b-icon> Edit
                                    </b-button>
                                    <b-button variant="outline-secondary" @click="removeAttribute(custom_attribute.id)">
                                        <b-icon icon="trash"></b-icon> Delete
                                    </b-button>
                                </b-button-group>
                            </div>
                        </b-button-toolbar>
                    </div>
                </div>

                <div class="row py-2 float-right" v-if="paginatedData.length > 0">
                    <b-pagination-nav v-model="pagination.currentPage" :number-of-pages="pagination.pages"
                        prev-text="Previous" next-text="Next" base-url="#" first-number last-number></b-pagination-nav>
                </div>
                <div class="row p-2" v-if="paginatedData.length == 0">
                    {{ blankmsg }}
                </div>
            </div> -->
        </b-overlay>


        <!-- alpha fix- maked title dynamic  -->
        <b-modal id="bv-modal-example" size="lg" hide-footer :title=custom_filed_title>


            <!--<ul class="list-group mb-3 " v-if='errormsg'>
                    <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
                </ul>-->

            <b-overlay :show="showoverlaymodal" rounded="sm">
                <b-form @submit.stop.prevent="onSubmit">
                    <input type="hidden" v-model="fdata.id" name="id">

                    <!-- alpha fix- maked it row wise -->
                    <div class="clearfix">

                        <div class="row">
                            <div class="col-md-6">
                                <b-form-group id="label-group" class="mr1" label="Label *" label-for="label">
                                    <b-form-input id="label" name="label" v-model="fdata.label"
                                        v-validate="{ required: true, min: 3 }" :state="validateState('label')"
                                        aria-describedby="label-feedback" data-vv-as="Attribute Label"></b-form-input>
                                    <b-form-invalid-feedback id="label-feedback">{{ veeErrors.first('label')
                                        }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>

                            <div class="col-md-6">
                                <b-form-group id="note-group" class="" label="Note" label-for="note">
                                    <b-form-input id="note" name="note" v-model="fdata.note"></b-form-input>
                                </b-form-group>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col-md-6">
                                <b-form-group id="type-group" class=" mr1" label="Type" label-for="type">
                                    <!-- Mustafijur: 13-05-2026 -->
                                    <b-form-select id="type" name="type" :disabled="disableme" v-model="fdata.type"
                                        v-validate="{ required: true }" :options="types" :state="validateState('type')"
                                        aria-describedby="type-feedback" data-vv-as="Type"></b-form-select>
                                    <b-form-invalid-feedback id="type-feedback">{{ veeErrors.first('type')
                                    }}</b-form-invalid-feedback>
                                </b-form-group>

                            </div>

                            <div class="col-md-6">
                                <b-form-group v-if="fdata.type != 2 && fdata.type != 5 && fdata.type != 8"
                                    id="link_to_contract-group" class="" label="Linked To Contract"
                                    label-for="link_to_contract">
                                    <b-form-select id="link_to_contract" name="type" v-model="fdata.link_to_contract"
                                        :options="yes_no"></b-form-select>
                                </b-form-group>

                            </div>
                        </div>
                        <div class="col-md-6">

                            <!-- 20-04-2026 - Start: Sifat - For CTC module -->
                            <b-form-group v-if="is_ctc_module_available && fdata.type == 7" id="link_to_ctc-group"
                                class="" label="Linked To CTC" label-for="link_to_ctc">
                                <b-form-select id="link_to_ctc" name="link_to_ctc" v-model="fdata.link_to_ctc"
                                    :options="yes_no"></b-form-select>
                            </b-form-group>
                            <!-- 20-04-2026 - End: Sifat - For CTC module -->

                        </div>

                         <!-- alpha fix- maked it row ends -->

                    </div>

                    <template v-if="fdata.type > 6" class="row">

                        <div class="col-md-12">
                            <div class="clearfix mt-3">
                                <div v-if="custom_options.length > 0">Existing Options</div>

                                <div class="row ml-3 mb-2" v-for="(row, index) in custom_options">
                                    <div class="col-md-2 pt-1">{{ 'Option ' + parseInt(index + 1) }}</div>
                                    <div class="col-md-8"><b-form-input class="check_required" v-model="row.label"
                                            :name="`option_${row.id}`"></b-form-input></div>
                                    <div class="col-md-2"><b-icon icon="trash-fill" aria-hidden="true" font-scale="1.5"
                                            v-on:click="removeExistingElement(row.id);"></b-icon></div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="clearfix mt-3">
                                <div v-if="new_custom_options.length > 0">New Options</div>

                                <div class="row ml-3 mb-2" v-for="(row, index) in new_custom_options">
                                    <div class="col-md-2 pt-1">{{ 'Option ' + parseInt(index + 1) }}</div>
                                    <div class="col-md-8"><b-form-input v-model="row.input"></b-form-input></div>
                                    <div class="col-md-2"><b-icon icon="trash-fill" aria-hidden="true" font-scale="1.5"
                                            v-on:click="removeElement(index);"></b-icon></div>
                                </div>
                            </div>
                        </div>



                    </template>
                    <div class="full-width text-center mt-3">
                        <b-button type="submit" variant="primary">{{ newattribute ? 'Submit' : 'Update' }}</b-button>
                        <b-button class="ml-2 custom-wizard-btn" @click="resetForm()">Reset</b-button>
                        <b-button size="sm" variant="primary" class="float-right" @click="addRow" v-if="fdata.type > 6">
                            + New Option
                        </b-button>
                    </div>
                </b-form>
            </b-overlay>
        </b-modal>

    </div>
</template>


<script>
export default {

    mounted() {
        //console.log('Bank info started..');
        //console.log(this.employee_id);

    },
    data() {

        return {
            cu: window.location.href,
            ce: false,


            pagetitle: 'Custom Attribute',
            search: '',
            listdata: [],
            custom_attributes: [],
            new_custom_options: [],
            custom_options: [],
            custom_option_counter: 0,
            successmsg: '',
            errormsg: [],
            blankmsg: 'Fetching data..',
            fdata: { id: null, label: "", note: "", type: "0", link_to_contract: "0", link_to_ctc: "0" },  // 20-04-2026 - Sifat - For CTC module

            showoverlay: false,
            showoverlaymodal: false,
            disableme: false,
            is_ctc_module_available: false, // 20-04-2026 - Start: Sifat - For CTC module

            /*
            1 for single line, 2 for multiline, 3 for date, 3 for date, 4 for number, 5 for file, 6 for single option, 7 for multi option, 8 for yes_no
            */

            types: [
                { value: "0", text: "Select..." },
                { value: "1", text: "Single Line Text" },
                { value: "2", text: "Multiple Line Text" },
                { value: "3", text: "Date" },
                { value: "4", text: "Number" },
                { value: "5", text: "File" },
                { value: "6", text: "Yes/No" },
                { value: "7", text: "Single Select Dropdown" },
                { value: "8", text: "Multiple Select Dropdown" },

            ],
            length: 20,
            temp_length: 20,
            length_options:
                [
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ],

            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },

            tmp: 1,
            yes_no: [
                { value: "0", text: "No" },
                { value: "1", text: "Yes" },
            ],

            newattribute: true,

            // alpha fix- added this
            custom_filed_title: "Add Custom Attribute Details",

        }
    },
    methods: {
        checkRequired: function () {

            var y = document.getElementsByClassName("check_required");
            var i;
            for (i = 0; i < y.length; i++) {
                if (y[i].value == '') {
                    this.$bvToast.toast("Option data can not be empty.", {
                        title: `Warning!`,
                        variant: 'warning',
                        solid: true
                    });
                    return false;
                }
            }

            return true;
        },
        addRow: function () {

            this.new_custom_options.push({
                //input: "option_"+this.tmp,
                input: "",
            });

            this.tmp++;
        },
        removeElement: function (index) {
            this.new_custom_options.splice(index, 1);
        },
        removeExistingElement: function (id) {

            if (!this.checkNet()) return false;

            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this department.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('option_id', id);
                        axios.post(this.$api_url + '/custom/attribute/option/delete', formData)
                            .then(function (response) {
                                if (response.data == 1) {
                                    this.$bvToast.toast('Deleted!', {
                                        title: `Success`,
                                        variant: 'success',
                                        solid: true
                                    });

                                    this.getCustomAttributeOptions();
                                }
                                else {
                                    this.$bvToast.toast("You can't delete this option since this has already been used for one or some employees.", {
                                        title: `Failed`,
                                        variant: 'danger',
                                        solid: true
                                    });
                                }



                            }.bind(this))
                            .catch(function (error) {
                                currentObj.serverError(error);
                            });
                    }

                });

        },
        removeAttribute: function (id) {
            if (!this.checkNet()) return false;

            let attribute = this.custom_attributes.find(attr => attr.id === id);

            if (attribute && attribute.is_ctc == 1) {
                let currentObj = this;
                axios.post(this.$api_url + '/cost-to-company/attribute/usage-check', { id: id })
                    .then(response => {
                        if (response.data.is_used) {
                            this.$bvToast.toast("This field is already connected with CTC head or CTC employee data. You can't delete this.", {
                                title: 'Action Prevented',
                                variant: 'warning',
                                solid: true
                            });
                        } else {
                            this.performRemove(id);
                        }
                    })
                    .catch(error => {
                        currentObj.serverError(error);
                    });
            } else {
                this.performRemove(id);
            }
        },
        performRemove: function (id) {
            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this field.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', id);
                        axios.post(this.$api_url + '/custom/attribute/delete', formData)
                            .then(function (response) {
                                if (response.data == 1) {
                                    this.$bvToast.toast('Deleted!', {
                                        title: `Success`,
                                        variant: 'success',
                                        solid: true
                                    });
                                    this.getCustomAttributeData();
                                } else {
                                    this.$bvToast.toast("You can't delete this field since this has already been used for one or some employees.", {
                                        title: `Failed`,
                                        variant: 'danger',
                                        solid: true
                                    });
                                }
                            }.bind(this))
                            .catch(function (error) {
                                currentObj.serverError(error);
                            });
                    }
                });
        },

        getCustomAttributeData: function () {
            if (!this.checkNet()) return false;
            //this.showoverlay = true;
            axios.get(this.$api_url + '/custom/attribute/list', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                //console.log(response.data);
                this.custom_attributes = response.data;
                this.people = response.data.length;

                this.showoverlay = false;

                if (this.custom_attributes.length == 0)
                    this.blankmsg = "Nothing found.";
            }.bind(this));
        },
        checkCtcModule: function () {
            axios.get(this.$api_url + '/cost-to-company')
                .then(response => {
                    this.is_ctc_module_available = true; // 20-04-2026 - Sifat - For CTC module
                })
                .catch(error => {
                    this.is_ctc_module_available = false; // 20-04-2026 - Sifat - For CTC module
                });
        },
        getCustomAttributeOptions: function () {
            if (!this.checkNet()) return false;
            //this.showoverlay = true;
            axios.get(this.$api_url + '/custom/attribute/options/' + this.fdata.id, {
                params: {

                }
            }).then(function (response) {
                //console.log(response.data);
                this.custom_options = response.data;
            }.bind(this));
        },
        editCustomAttribute: function (x) {
            if (!this.checkNet()) return false;
            let currentObj = this;

            this.newattribute = false;
            this.errormsg = [];
            this.successmsg = '';
            axios.get(this.$api_url + '/custom/attribute/details', {
                params: {
                    id: x
                }
            }).then(function (response) {
                this.fdata = response.data;

                if (this.fdata.type > 6)
                    this.getCustomAttributeOptions();

                this.disableme = true;
                this.$validator.reset();
            }.bind(this))
                .catch(function (error) {
                    currentObj.serverError(error);
                });

            this.$bvModal.show('bv-modal-example');
            // alpha fix- added this
            this.custom_filed_title = "Edit Custom Attribute Details";

        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetForm() {
            this.disableme = false;
            this.fdata = { id: null, label: "", note: "", type: "0", link_to_contract: "0", link_to_ctc: "0" }; // 20-04-2026 - Start: Sifat - For CTC module
            this.custom_options = [];
            this.new_custom_options = [];

        },
        addNewAttribute() {
            this.resetForm();
            this.$bvModal.show('bv-modal-example');
            this.newattribute = true;
            // alpha fix- added this
            this.custom_filed_title = "Add Custom Attribute Details";
        },
        onSubmit(e) {
            if (this.checkRequired() == false)
                return false;

            if (!this.checkNet()) return false;
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                //this.showoverlaymodal = true;
                e.preventDefault();
                let currentObj = this;

                let formData = new FormData();
                for (let [key, value] of Object.entries(this.fdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                    //console.log(`${key}: ${value}`);
                }

                if (this.custom_options.length > 0) {
                    let obj = [];
                    for (let [key, value] of Object.entries(this.custom_options)) {

                        //console.log(value.id + ' >> ' + value.label);
                        obj[value.id] = value.label;
                    }
                    formData.append('options', obj);
                }

                //return;

                if (this.new_custom_options.length > 0) {
                    let obj = [];
                    for (let [key, value] of Object.entries(this.new_custom_options)) {
                        var nm = `${key}`;
                        var fval = `${value.input}`;
                        obj[nm] = fval;
                    }

                    formData.append('tmp_options', obj);
                }

                axios.post(this.$api_url + '/custom/attribute/save', formData)
                    .then(function (response) {
                        this.custom_attributes = response.data;
                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });



                        this.$bvModal.hide('bv-modal-example');
                        this.showoverlaymodal = false;
                        this.resetForm();

                    }.bind(this))
                    .catch(function (error) {
                        console.log(error);
                        currentObj.serverError(error);
                        currentObj.errormsg = error.response.data.errors;
                        for (var data in currentObj.errormsg) {
                            var msg = currentObj.errormsg[data];
                            currentObj.$bvToast.toast(msg, {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                            });
                            currentObj.$validator.reset();
                        }
                    });
                this.showoverlay = false;
            });
        },



    },
    created: function () {
        this.checkCtcModule();
        this.getCustomAttributeData();
        Fire.$on('reloadUsers', () => { this.getCustomAttributeData() })
    },
    computed:
    {
        filteredData() {
            let filtered_list = this.custom_attributes;
            if (this.search) {
                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1; }) });

                if (filtered_list.length == 0)
                    this.blankmsg = "Nothing found.";
            }

            return filtered_list;
        },
        paginatedData() {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        }
    },
    watch: {
        'fdata.type': function (newVal, oldVal) {
            if (oldVal == '7' && newVal != '7') {
                this.fdata.link_to_ctc = '0';
            }
        }
    }
}
</script>
